import {
  WSControl,
  WSControlGroup,
  WSField,
  WSForm,
  WSPanel
} from "@wingspanhq/fe-component-library";
import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import {
  REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY,
  REVIEW_STRATEGY_ON_FAIL_COPY
} from "../CreateRequirementDefinitionForm/utils";

type FormSectionApprovalsProps = {
  isRequirementWithErrorStates: boolean;
};

export const FormSectionApprovals: React.FC<FormSectionApprovalsProps> = ({
  isRequirementWithErrorStates
}) => {
  const { register } = useFormContext();

  useEffect(() => {
    register("reviewStrategy");
    register("isApprovalRequired");
  }, [register]);

  return (
    <WSPanel>
      <WSField
        helperText="Set whether your approval is required when contractor submits a requirement"
        label="Approvals"
        mb="M"
      />
      {isRequirementWithErrorStates ? (
        <WSForm.Field
          component={WSControlGroup}
          componentProps={{
            options: [
              {
                label: REVIEW_STRATEGY_ON_FAIL_COPY,
                value: RequirementReviewStrategy.OnFail
              },
              {
                label: REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY,
                value: RequirementReviewStrategy.AlwaysRequired
              }
            ],
            size: "S",
            type: "radio"
          }}
          name="reviewStrategy"
        />
      ) : (
        <WSForm.Value name="isApprovalRequired">
          {(isApprovalRequired: boolean) => (
            <WSForm.Field
              component={WSControl}
              componentProps={{
                size: "S",
                type: "switch"
              }}
              label={`Approvals ${isApprovalRequired ? "on" : "off"}`}
              name="isApprovalRequired"
            />
          )}
        </WSForm.Value>
      )}
    </WSPanel>
  );
};
